import { render, staticRenderFns } from "./likeNum.vue?vue&type=template&id=0d89ef52&scoped=true&"
import script from "./likeNum.vue?vue&type=script&lang=js&"
export * from "./likeNum.vue?vue&type=script&lang=js&"
import style0 from "./likeNum.vue?vue&type=style&index=0&id=0d89ef52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d89ef52",
  null
  
)

export default component.exports